import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router-dom'
// import IconKey from '@material-ui/icons/VpnKey';
import IconAccount from '@material-ui/icons/AccountBox';
import IconMission from '@material-ui/icons/FormatListBulleted';
import IconProfile from '@material-ui/icons/FolderShared';
import IconLogout from '@material-ui/icons/WifiOff';

class IconSet extends Component {
  //   componentDidMount() {
  //   const path = './assets/images/'+this.props.icons+'_'+this.props.size+'.png';
  //   import(`${path}`)
  //     .then(module => this.setState({ icons: module.default }))
  // }
  constructor(props) {
    super(props);
    this.state={menuEl: undefined}
    this._toggleHover = this._toggleHover.bind(this);
    this._handleClose = this._handleClose.bind(this);
  }
  _onClick(e, url) {
    window.setTimeout(function() {
      if (url) this.props.history.push(url);
    }.bind(this), 50);
    if (this.props.onClick) window.setTimeout(function() {this.props.onClick(e, url);}.bind(this), 150);
  }
  _handleClose(e) {
    // console.log('closing!', e.target,
    const url = e.target.getAttribute('url')
    this.props.history.push(url);
  }
  _toggleHover(e) {
    const { menuEl } = this.state;
    e.stopPropagation();
    this.setState({menuEl: menuEl !== undefined ? undefined : e.target})
  }
  render() {
    const { icon, title, url, className, items, sets, style, iconSize, showTooltip, showLabel, subMenu, iconButton, iconWidth, iconHeight, buttonStyle} = this.props;
    const size = this.props.size;
    const width = iconWidth || size || 56;
    const height = iconHeight || size || 56;
    const xFound = items.indexOf(icon);
    const xIdx = xFound >= 0 ? xFound : 0;
    const yIdx = 0;
    let iconStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: xIdx*(iconSize || width)*-1+'px '+yIdx*height*-1+'px',
      width: iconSize || width,
      height: iconSize || height,
      display: 'inline-block',
      verticalAlign: 'middle',
      ...(style ? style : {})
    }
    let iconSVGStyle = {
      width: iconSize-10 || width-10,
      height: iconSize-10 || height-10,
      display: 'inline-block',
      verticalAlign: 'middle',
      ...(style ? style : {})
    }
    // if (style !== undefined)
    // iconStyle = {...iconStyle, ...style};

    if (sets['size_'+size])
    iconStyle.backgroundImage = 'url('+sets['size_'+size]+')';
    else
    console.log('uknown size', size)


    // return (
    //   <Link to={url} className={className} style={{width: showLabel === true ? 'auto': width, height, ...linkStyle}} onClick={(e) => { onClick(e, url) } || undefined}>
    //
    //     <IconButton aria-label="Delete" style={{width: showLabel === true ? 'auto': width, height}} className="button">
    //       <span className="icon" style={iconStyle}></span>
    //       <If condition={showTooltip !== false}>
    //         <span className="tooltip">
    //           <span className="arrow"></span>
    //           <span className="content">
    //             {title}
    //           </span>
    //         </span>
    //       </If>
    //       <If condition={showLabel === true}>
    //         <span className="label">
    //           {title}
    //         </span>
    //       </If>
    //     </IconButton>
    //   </Link>
    // );
    const toolTip = (<If condition={showTooltip !== false}>
      <span className="tooltip">
        <span className="arrow"></span>
        <span className="content">
          {title}
        </span>
      </span>
    </If>);


    const { menuEl } = this.state;

    const menu = (<If condition={subMenu !== undefined && subMenu !== false}>
      <Menu
      id="header-menu"
      anchorEl={menuEl}
      open={Boolean(menuEl)}
      onClose={this._handleClose}
    >
    {subMenu.map((s, i) => {
      return <MenuItem url={s.get('url')} key={'sm_'+i} onClick={this._handleClose}>{s.get('label')}</MenuItem>
    }).toArray()}
    </Menu>


    </If>);

    const label = (<If condition={showLabel === true}>
      <span className="label" onClick={(e) => {  this._onClick(e, url) } || undefined}>
        {title}
      </span>
    </If>);

    let iconEl;
    if (icon === 'login')
      iconEl = <IconAccount style={iconSVGStyle} className="icon"/>;
    else if (icon === 'missions')
      iconEl = <IconMission style={iconSVGStyle} className="icon"/>;
    else if (icon === 'profile')
      iconEl = <IconProfile style={iconSVGStyle} className="icon"/>;
    else if (icon === 'logout')
      iconEl = <IconLogout style={iconSVGStyle} className="icon"/>;
    else
      iconEl = <span className="icon" style={iconStyle}></span>

    if (iconButton === true)
    return (
      <span className={className} >
      <IconButton aria-label={title} style={{width: showLabel === true ? 'auto': width, height, ...buttonStyle}} onClick={(e) => {  this._onClick(e, url) } || undefined} onMouseEnter={this._toggleHover} >
        {iconEl}
        {toolTip}
        {menu}
      </IconButton>
      {label}
      </span>

    );
    else
    return (
      <span style={{display: 'inline-block',width: showLabel === true ? 'auto': width, height}} className={className}><span style={iconStyle}></span>
      {menu}
      {label}
    </span>
  );
}
}

export default withRouter(IconSet);



// WEBPACK FOOTER //
// ./src/components/Icon/IconSet.jsx